import React, { Fragment, Component } from 'react';
import Title from './Title';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getAllVendor } from '../../Graphs/Vendor/listVendor';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Spin, notification, Button } from 'antd';
import { addVendor } from '../../Graphs/Vendor/addVendor';
import VendorRecordsTable from './VendorRecordsTable';
import { AddVendor } from './AddVendor';

class Vendor extends Component {
	constructor(props) {
		super(props);
		this.state = {
			vendorList: [],
			vendorTotal: 0,
			isLoading: false,
			primaryColor: '#4466f2',
			envData: null,
		};
	}

	async componentDidMount() {
		try {
			const { setRouteName, setSearchText } = this.props;
			let editPrimaryColor = await localStorage.getItem('primary_color');

			await setRouteName('VENDOR');
			await setSearchText('');

			this.setState({
				isLoading: true,
				primaryColor: editPrimaryColor,
			});

			await this.listVendorData();
		} catch (e) {
			notification['error']({
				message: 'Vendor',
				description: typeof e === 'string' ? e : 'Something went wrong',
			});
		} finally {
			this.setState({
				isLoading: false,
			});
		}
	}

	listVendorData = async () => {
		const {
			authToken,
			history,
			setLoginFlag,
			setUserData,
			setUserToken,
			setListVendorData,
			setListVendorDataTotal,
		} = this.props;

		try {
			this.setState({
				isLoading: true,
			});

			let vendorData = await getAllVendor(authToken, 0, 10);

			if (vendorData.status === 200) {
				//set category data
				await setListVendorData(vendorData.data);
				await setListVendorDataTotal(vendorData.total);

				this.setState({
					vendorList: vendorData.data,
					vendorTotal: vendorData.total,
				});
			} else if (vendorData.status === 401) {
				await setLoginFlag(false);
				await setUserData(null);
				await setUserToken(null);
				history.push(`${process.env.PUBLIC_URL}/login`);
			}
		} catch (e) {
			throw e;
		} finally {
			this.setState({
				isLoading: false,
			});
		}
	};

	addSubmit = async (values) => {
		try {
			const { authToken } = this.props;
			this.setState({
				isLoading: true,
			});
			let addCategoryData = await addVendor(authToken, values);
			await this.listVendorData();
		} catch (e) {
			console.log('!!!!!!!!e', e);
			notification['error']({
				message: 'Add Vendor',
				description: typeof e === 'string' ? e : 'Something went wrong',
			});
		} finally {
			this.setState({
				isLoading: false,
			});
		}
	};

	render() {
		const { primaryColor, vendorList, isLoading, vendorTotal } = this.state;

		return (
			<Fragment>
				<Title parent="Vendors" title="Vendors" />

				<div
					style={{
						marginTop: '20px',
						display: 'inline-block',
						width: '100%',
						marginBottom: '20px',
						paddingLeft: '14px',
						paddingRight: '55px',
					}}
				>
					<div style={{ float: 'left', cursor: 'pointer' }}>
						<AddVendor
							primaryColor={primaryColor}
							onSubmit={this.addSubmit}
							authToken={this.props.authToken}
						/>
					</div>
				</div>

				<div className="container-fluid">
					{isLoading ? (
						<div style={{ marginLeft: '20px' }}>
							<Spin size="large" style={{ marginLeft: '480px', marginTop: '130px' }} />
						</div>
					) : (
						<div>
							<VendorRecordsTable
								data={vendorList}
								primaryColor={primaryColor}
								vendorTotal={vendorTotal}
							/>
						</div>
					)}
				</div>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	authToken: state.auth.authToken,
});

const mapDispatchToProps = (dispatch) => {
	return {
		setLoginFlag: (flag) => {
			dispatch({
				type: 'SET_LOGIN_FLAG',
				flag: flag,
			});
		},
		setUserData: (userData) => {
			dispatch({
				type: 'SET_USER_DATA',
				userData: userData,
			});
		},
		setUserToken: (authToken) => {
			dispatch({
				type: 'SET_USER_AUTHTOKEN',
				authToken: authToken,
			});
		},
		setListVendorData: (listVendorData) => {
			dispatch({
				type: 'SET_LIST_VENDOR_DATA',
				listVendorData: listVendorData,
			});
		},
		setListVendorDataTotal: (listVendorDataTotal) => {
			dispatch({
				type: 'SET_LIST_VENDOR_DATA_TOTAL',
				listVendorDataTotal: listVendorDataTotal,
			});
		},
		setRouteName: (routeName) => {
			dispatch({
				type: 'SET_ROUTE_NAME',
				routeName: routeName,
			});
		},
		setSearchText: (searchText) => {
			dispatch({
				type: 'SET_SEARCH_TEXT',
				searchText: searchText,
			});
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Vendor));
